var _ = require('underscore');
var moment = require('moment');
var TorsoFormView = require('backbone-torso/modules/FormView');
var TorsoFormModel = require('backbone-torso/modules/FormModel');
var EregAuthBarcodeSecurityQuestionFormModel = require('./EregAuthBarcodeSecurityQuestionFormModel');
var eregAuthBarcodeSecurityQuestionTemplate = require('./eregAuthBarcodeSecurityQuestionTemplate.hbs');
// Hard coded year value since we're only validating MM/DD. This is, in fact, a leap year
var CONSTANT_YEAR_VALUE = '3004';

/**
 * Form View for E-reg Barcode Security Question
 *
 * @class EregAuthBarcodeSecurityQuestionView
 * @constructor
 */
module.exports = TorsoFormView.extend({
  className: 'auth-main auth-main--express-checkin auth-main__login-form-content auth-main__login-form-content--express-checkin',
  template: eregAuthBarcodeSecurityQuestionTemplate,

  events: {
    'click [data-submit-security-question]': '_submitSecurityQuestion',
    'click [data-cancel-authentication]': '_cancelAuthentication'
  },

  prepareFields: {
    monthList: function() {return moment.monthsShort();},
    dayList: function() {
      if (this.model.get('month')) {
        return this._getDayList(this.model.get('month'));
      }
    }
  },

  /**
   * Configures feedback bindings.
   * @property feedback {Array} of When/Then Feedbacks
   */
  feedback: [{
    /**
     * On change in submitting viewState, decide if the Proceed button should be disabled.
     * @property feedback[0] (Disable Proceed Button) {When/Then Feedback}
     */
    when: {
      'on': ['change:submitting']
    },
    then: function() {
      var submitting = this.get('submitting');
      if (submitting) {
        return {
          addClass: 'brec-btn--disabled',
          attr: ['disabled', 'disabled']
        };
      } else {
        return {
          removeClass: 'brec-btn--disabled',
          removeAttr: 'disabled'
        };
      }
    },
    to: 'data-submit-security-question'
    }, {
    /**
     * On change in submitting viewState, decide if the Cancel button should be disabled.
     * @property feedback[1] (Disable Cancel Button) {When/Then Feedback}
     */
    when: {
      'on': ['change:submitting']
    },
    then: function() {
      var submitting = this.get('submitting');
      if (submitting) {
        return {
          addClass: 'brec-btn--disabled',
          attr: ['disabled', 'disabled']
        };
      } else {
        return {
          removeClass: 'brec-btn--disabled',
          removeAttr: 'disabled'
        };
      }
    },
    to: 'data-cancel-authentication'
    }
  ],

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    this.model = new EregAuthBarcodeSecurityQuestionFormModel();
    _.bindAll(this, '_submitSecurityQuestion', 'formatDob', 'setSubmitState');
    this.listenTo(this.model, 'change:month', this.render);
    this.listenTo(this.model, 'change:month', this._resetDayValue);
    this.listenTo(this, 'change:errors', this.render);
  },

  /**
   * Formats the Date of Birth for the authentication perspective
   * @method formatDob
   * @returns a formatted string of the month/day of birth: --mm-dd
   */
  formatDob: function() {
    var month = this.model.get('month');
    var day = this.model.get('day');
    var date = moment(CONSTANT_YEAR_VALUE + ' ' + month + ' ' + day, 'YYYY MMM DD');
    return date.format('--MM-DD');
  },

  /**
   * Sets the submit state of the security view
   * @method setSubmitState
   * @param state {Boolean} the submit state
   */
  setSubmitState: function(state) {
    this.set('submitting', state);
  },

  /**
   * Resets the day if it is not valid
   * @method _resetDayValue
   * @private
   */
  _resetDayValue: function() {
    var month = this.model.get('month');
    var day = this.model.get('day');
    var isValidDay = moment(CONSTANT_YEAR_VALUE + ' ' + month + ' ' + day, 'YYYY MMM DD').isValid();
    if (!isValidDay) {
      this.model.set('day', '');
    }
  },

  /**
   * Updates the dropdown options for days
   * @method _getDayList
   * @param selectedMonth the month (1 index)
   * @private
   */
  _getDayList: function(selectedMonth) {
    var date = moment(CONSTANT_YEAR_VALUE + ' ' + selectedMonth, 'YYYY MMM');
    var daysInMonth = date.daysInMonth();
    // range is exclusive
    return _.range(1, daysInMonth + 1);
  },

  /**
   * Cancels the security question authentication
   * @method _cancelAuthentication
   * @private
   */
  _cancelAuthentication: function() {
    if (this.get('submitting')) {
      return;
    }
    this.model = new TorsoFormModel();
    this.trigger('cancelAuthentication');
  },

  /**
   * Submits security question to the application
   * @method _submitSecurityQuestion
   * @private
   */
  _submitSecurityQuestion: function() {
    if (this.get('submitting')) {
      return;
    }
    this.set('errors', []);
    var validationErrors = this.model.validate();
    if (validationErrors) {
      this.set('errors', validationErrors);
    } else {
      this.setSubmitState(true);
      this.trigger('authenticatePatient');
    }
  }
});
